import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import submit from "submit-form";
import { ExploreSelector } from "../components/ExploreSelector";
import { learnSections, widgetTypesList } from "../data/widgetsLists";

const LearnMore = ({ section }) => {
  const data = learnSections[section] || learnSections.recipe;
  return (
    <main className="widgets">
      <header>
        <hgroup className="widget-left-header mobile-hidden">
          <SvgIcon
            src={"/img/new-icons/back-button.svg"}
            onClickFn={() =>
              submit(`/actions/refresh/?`, {
                method: "GET",
                body: { section: "", learn: "" },
              })
            }
          />
          <div>
            <h3>Widgets</h3>
            <p className="p4">
              Widgets are custom features you can add to your app to create more
              value for your users. Explore the options available below to begin
              building out custom features in your app.
            </p>
          </div>
        </hgroup>
        <hgroup className="widget-left-header">
          <ExploreSelector
            widgetTypesList={widgetTypesList}
            defaultWidget={
              widgetTypesList[
                widgetTypesList.findIndex(
                  (widget) => widget.learnmoreLink === section
                )
              ] || widgetTypesList[0]
            }
          />
        </hgroup>
        <a
          href={`/actions/refresh?modal[type]=create-widget`}
          role="button"
          data-button-type="primary"
        >
          <SvgIcon src="/img/new-icons/add.svg" noFilterOnLight={true} />
          <span>Add New Widget</span>
        </a>
      </header>
      <section className="only-show-mobile back-handler">
        <SvgIcon
          src={"/img/new-icons/back-button.svg"}
          onClickFn={() =>
            submit(`/actions/refresh/?`, {
              method: "GET",
              body: { section: "", learn: "" },
            })
          }
        />
        <h3>Explore</h3>
      </section>
      <section className="learn-more-container">
        <SvgIcon noFilterOnLight={true} src={data.banner} />
        <div>
          <div>
            <header>
              <h3>{data.title}</h3>
              <p className="p1">{data.description}</p>
            </header>
            <div>
              <p className="p6">How it works:</p>
              <ul>
                {data.howWork.map((step, i) => (
                  <li>
                    <p className="p1">{step}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div>
            <p className="p6">Icons:</p>
            <div className="icons-container">
              {data.icons.map((icon) => (
                <SvgIcon src={icon} />
              ))}
            </div>
            <p className="p6">{data.installDescription}</p>
            <a
              role="button"
              data-button-type="outline"
              href={`/actions/refresh?modal[type]=install-widget&widgetModal[type]=${section}`}
              sz="large"
            >
              <span>Install now</span>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default LearnMore;
